import { gql } from '@apollo/client';

/**
 * The content review queue: posts and comments members have reported.
 * Moderators only (PARTNER_LEADERSHIP / PARTNER_MEMBERSHIP_OFFICER), enforced server-side.
 */
export const GET_REPORTED_CONTENT = gql`
query ReportedContent($onlyUnderReview: Boolean) {
  reportedContent(onlyUnderReview: $onlyUnderReview) {
    contentType
    contentId
    reviewStatus
    reportCount
    reportedAt
    reasons
    title
    content
    author { id name }
    reporters { id name }
  }
}`;
